<template>
  <div class="car-unpetrified-com">
    <div class="header">
      <!--      <div>重点客户管理——全部客户列表</div>-->
      <el-form :inline="true">
        <el-form-item label="统计月份">
          <el-date-picker
              v-model="formData.time"
              type="month"
              format="yyyy年MM月"
              value-format="yyyyMM"
              placeholder="选择月">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="省市区" label-width="75px">
          <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
          <el-cascader
              v-if="areaListPr.length>0"
              :options="areaListPr"
              v-model="formData.provCityCounty"
              :props="propsData()"
              clearable></el-cascader>
        </el-form-item>
        <el-form-item label="开发记录" label-width="75px">
          <el-select v-model="formData.devLog" placeholder="请选择">
            <el-option
                v-for="item in devLogOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="value1">
          <el-form-item label="" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-input v-model="formData.companyName" clearable placeholder="请输入企业名称"></el-input>
          </el-form-item>
          <el-form-item label="" label-width="75px">
            <!--            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>-->
            <el-input v-model="formData.cmpnanyDevUser" clearable placeholder="请输入开发人"></el-input>
          </el-form-item>
          <!--          <el-form-item label="" label-width="75px">-->
          <!--            &lt;!&ndash;            <WeekPopover @on-command="onWeekPopOverCommand" ref="weekPopoverRef"/>&ndash;&gt;-->
          <!--formData          </el-form-item>-->
          <el-form-item label="客户状态" label-width="75px">
            <el-select v-model="formData.companyCardStatus"
                       multiple
                       collapse-tags
                       style="width: 250px"
                       placeholder="请选择">
              <el-option
                  v-for="item in companyCardStatusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <!--          <el-form-item label="车机触达" label-width="75px">-->
          <!--            <el-select v-model="formData.reachStatus" placeholder="请选择">-->
          <!--              <el-option-->
          <!--                  v-for="item in reachStatusOptions"-->
          <!--                  :key="item.value"-->
          <!--                  :label="item.label"-->
          <!--                  :value="item.value">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item label="开发状态" label-width="75px">
            <el-select v-model="formData.devStatus" placeholder="请选择">
              <el-option
                  v-for="item in devStatusOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加油卡类型" label-width="85px">
            <el-select v-model="formData.cardType" placeholder="请选择">
              <el-option
                  v-for="item in cardTypeOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="车辆规模" label-width="75px">
            <el-select v-model="formData.vehicleCountMask" placeholder="请选择">
              <el-option
                  v-for="item in vehicleCountMaskOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运营公里数" label-width="85px">
            <el-select v-model="formData.mileageMask" placeholder="请选择">
              <el-option
                  v-for="item in mileageMaskOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="停靠石化油站次数占比">
            <el-select v-model="formData.percentage" placeholder="不限" style="width:110px;">
              <el-option label="不限" value></el-option>
              <el-option label="0-10%" value="0-10"></el-option>
              <el-option label="10-20%" value="10-20"></el-option>
              <el-option label="20-30%" value="20-30"></el-option>
              <el-option label="30-40%" value="30-40"></el-option>
              <el-option label="40-50%" value="40-50"></el-option>
              <el-option label="50-60%" value="50-60"></el-option>
              <el-option label="60-70%" value="60-70"></el-option>
              <el-option label="70-80%" value="70-80"></el-option>
              <el-option label="80-90%" value="80-90"></el-option>
              <el-option label="90%以上" value="90-100"></el-option>
            </el-select>
          </el-form-item>
          <!--        <WeekDialog @on-command="onWeekDialogCommand" v-if="showWeekDialog"/>-->
        </template>
        <el-button style="margin-left:30px;" class="searchBtn" @click="onSearch(null)">查询</el-button>
        <el-button style="margin-left:10px;" v-permission="'customer:dataSetting'" @click="showDataSourceDialog">数据源配置</el-button>
        <el-switch
            v-model="value1"
            style="margin-left: 10px"
            @change="changeSearch"
            active-text="展开"
            inactive-text="收起">
        </el-switch>
      </el-form>
    </div>
    <main>
      <el-table :data="tableData" :max-height="tableHeight1" stripe>
        <el-table-column fixed type="index" width="50" align="center" label="序号"></el-table-column>
        <el-table-column prop="companyName" width="200" fixed label="企业名称" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.decryptedCompanyName">{{ scope.row.companyName }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer" @click="scope.row.decryptedCompanyName = true">{{
                  scope.row.companyNameMask
                }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="companyCreditCode" width="200" label="统一社会信用代码" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.companyCreditCodeIs">{{ scope.row.companyCreditCode }}</span>
            <el-tooltip v-else placement="top" content="点击解密">
              <span style="cursor: pointer" @click="scope.row.companyCreditCodeIs = true">{{
                  scope.row.companyCreditCodeMask
                }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="oilConsumption" label="柴油量估算(吨)" width="150" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
              <div class="proTextSty">
                根据企业名下所有运营柴油车辆对应吨位百公里油耗，乘以相应运营里程计算得出。1吨=1176升。下附车型油耗表。
              </div>
              <div class="tableTitleSty">车型油耗表</div>
              <el-table :data="gridData" border>
                <el-table-column width="185" align="center" property="date" label="车辆吨位区间"></el-table-column>
                <el-table-column align="center" property="name" label="平均每百公里油耗(升)"></el-table-column>
              </el-table>
              <span slot="reference">
                <span style="margin-right: 5px">柴油量估算(吨)</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="vehicleOperatorCount" label="运营车辆数" width="100" align="center"></el-table-column>
        <el-table-column prop="petrochemicalStopRadio" label="停靠石化油站次数占比" width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{
                scope.row.petrochemicalStopRadio && scope.row.petrochemicalStopRadio != '-' ? scope.row.petrochemicalStopRadio + '%' : scope.row.petrochemicalStopRadio
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="petrochemicalStopRadio" label="停靠石化油站次数环比" width="100"
                         align="center">
          <template slot-scope="scope">
            <span>{{
                scope.row.petrochemicalStopRadioMom && scope.row.petrochemicalStopRadioMom != '-' ? scope.row.petrochemicalStopRadioMom + '%' : scope.row.petrochemicalStopRadioMom
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="petrochemicalStopCount" label="S级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="petroleumStopCount" label="C级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="otherStopCount" label="E级油站停靠次数" align="center"></el-table-column>
        <el-table-column prop="cardTypeText" label="加油卡类型" width="100" align="center"></el-table-column>
        <el-table-column prop="cardCount" label="联名卡办卡数量" width="150" align="center"></el-table-column>
        <el-table-column prop="lastOpetime" label="最后一次联名卡消费时间" width="200" align="center"></el-table-column>
        <el-table-column prop="" label="近6个月平均消费" width="150" align="center"></el-table-column>
        <el-table-column prop="otherStopCount" width="150" align="center" label="办卡信息">
          <template slot-scope="scope">
            <span v-if="scope.row.cardType == '3'">-</span>
            <span v-else style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="provname" label="所属省份" align="center"></el-table-column>
        <el-table-column prop="cityname" label="所属城市" align="center"></el-table-column>
        <el-table-column prop="countyname" label="所属区县" align="center"></el-table-column>
        <el-table-column prop="runProvince" label="常运营省份按里程取TOP3" width="250" align="center"></el-table-column>
        <el-table-column prop="runProvince" label="停靠加油站TOP5" width="250" align="center">
          <template slot-scope="scope">
            <!--            <span v-if="scope.row.companyAddress==null">-</span>-->
            <!--            <span v-else style="color:#1137FF;cursor: pointer;" @click="toDetail(scope.row)">查看</span>-->
            <span style="color:#1137FF;cursor: pointer;" @click="seeTopFive(scope.row)">查看</span>
          </template>
        </el-table-column>
        <el-table-column prop="companyCardStatusText" label="客户状态" width="170" align="center">
          <template slot="header" slot-scope="scope">
            <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
              <div class="proTextSty">
                联名卡在用客户：近6个自然月有联名卡消费或有新增办卡的客户，对于非联名卡在用客户将根据其名下车辆停靠中国石化加油站占比区间定义客户状态为潜在新客户[0~10%)，摇摆客户[10%~20%)，低忠诚客户[20%~30%)，中忠诚客户[30%~50%)，高忠诚客户[50%~100%]。
              </div>
              <span slot="reference">
                <span style="margin-right: 5px">客户状态</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column prop="companyDevStatusText" label="开发状态" align="center"></el-table-column>
        <el-table-column prop="devUser" label="开发人" align="center"></el-table-column>
        <el-table-column prop="cmpnanyDevStartTime" width="150" label="开发开始时间" align="center"></el-table-column>
        <el-table-column prop="cmpnanyDevEndTime" width="150" label="开发结束时间" align="center"></el-table-column>
        <el-table-column prop="failedTypeText" width="150" label="开发失败原因" align="center"></el-table-column>
        <el-table-column prop="failedRemark" width="150" label="开发失败备注" align="center"></el-table-column>
        <el-table-column prop="reachStatusText" label="车机触达" align="center"></el-table-column>
        <el-table-column prop="vehicleCountMask" label="车辆规模" width="100" align="center"></el-table-column>
        <el-table-column prop="mileageMask" label="运营公里数" width="150" align="center"></el-table-column>
        <el-table-column prop="provname" fixed="right" width="150" align="center" label="领取任务">
          <template slot-scope="scope">
            <span
                v-if="scope.row.companyCardStatus==2&&scope.row.devStatus=='3'||scope.row.devStatus=='1'||scope.row.devStatus=='0'">-</span>
            <el-button v-else-if="scope.row.devStatus==2" :key="scope.row.devStatus" :disabled="true">任务已领取
            </el-button>
            <el-button v-else @click="getTask(scope.row)" :key="scope.row.devStatus" :disabled="scope.row.isHistory">
              领取任务
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="isRecord" fixed="right" width="150" align="center" label="开发记录">
          <template slot-scope="scope">
            <span v-if="scope.row.isRecord===1" style="color:#1137FF;cursor: pointer;" @click="seeDevLog(scope.row)">查看</span>
            <span v-else>-</span>
            <!--            <span style="color:#1137FF;cursor: pointer;" @click="seeDevLog(scope.row)">查看</span>-->
          </template>
        </el-table-column>
      </el-table>
    </main>
    <div class="block">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
                     @size-change="handleSizeChange"
                     :page-sizes="[50,100, 200]"
                     layout="prev, pager, next, jumper, sizes"
                     :total="total" style="margin:auto;"></el-pagination>
    </div>
    <detailCard @changeDetail="changeDetail" :isEdit="false" :nrData="nrData" v-if="isShowMes"></detailCard>
    <el-dialog title="领取任务" v-if="dialogFormVisible" :close-on-click-modal="false"
               width="808px" :visible.sync="dialogFormVisible">
      <el-form ref="form" class="formSty" :inline="true" label-position="top" :rules="rules" :model="form">
        <el-form-item label="客户名称" prop="companyNameMask">
          <el-tooltip placement="top" content="点击解密及复制">

            <div @click="showVal('companyNameMask','companyName')">
              <el-input v-model="form.companyNameMask" disabled
                        style="pointer-events: none;width: 357px;"
                        placeholder="请输入客户名称"
              ></el-input>
            </div>

          </el-tooltip>
        </el-form-item>
        <el-form-item label="统一社会信用代码" prop="companyCreditCodeMask">
          <el-tooltip v-if="isShowInput" placement="top" content="点击解密及复制">
            <div @click="showVal('companyCreditCodeMask','companyCreditCode')">
              <el-input v-model="form.companyCreditCodeMask" :disabled="true"
                        placeholder="请输入统一社会信用代码"
                        style="width: 357px;pointer-events: none;"></el-input>
            </div>
          </el-tooltip>
          <el-input v-else v-model="form.companyCreditCodeMask"
                    placeholder="请输入统一社会信用代码"
                    maxlength=18
                    style="width: 357px;"></el-input>
        </el-form-item>
        <el-form-item label="所属省份" prop="pr">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
          <el-select v-model="form.pr" :disabled="form.pr!=''" @change="prChange" style="width: 357px"
                     placeholder="请选择所属省份">
            <el-option
                v-for="item in proptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属城市" prop="ci">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属省/市/县" style="width: 357px"></el-input>-->
          <el-select v-model="form.ci" :disabled="form.ci!=''&&isChangeci" @change="ciChange" style="width: 357px"
                     placeholder="请选择所属城市">
            <el-option
                v-for="item in cioptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属区县" prop="cu">
          <!--          <el-input v-model="form.prcicu" disabled placeholder="请选择所属区县" style="width: 357px"></el-input>-->
          <el-select v-model="form.cu" :disabled="form.cu!=''&&isChangecu" style="width: 357px"
                     placeholder="请选择所属区县">
            <el-option
                v-for="item in cuoptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否已有普通卡" prop="commonCardStatus">
          <template slot="label">
            <el-popover
                placement="bottom"
                width="400"
                trigger="hover">
              <div class="proTextSty">
                请点击解密客户名称或统一社会信用代码，会自动复制该数据，可粘贴到加油卡查询系统中查询是否有办理过加油卡，如有，需选择“有”，并填写主卡卡号及对应有效卡数量；如没有，则选择“否”
              </div>
              <span slot="reference">
                <span style="margin-right: 5px">是否已有普通卡</span>
                <i class="el-icon-info"></i>
              </span>
            </el-popover>
          </template>
          <el-select v-model="form.commonCardStatus" style="width: 357px" placeholder="请选择">
            <el-option
                v-for="item in optionsCommonCardStatus"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
            v-if="form.commonCardStatus==1"
            v-for="(domain, index) in form.domains"
            :key="domain.key"
            :label="index==0?'普通卡主卡卡号及有效卡数量':''"
            :prop="'domains.' + index "
            :rules="{
        required: true, validator: ruleMobile, trigger: 'blur'
      }"
        >
          <div class="cardMesSty">
            <el-input style="width: 357px;margin-right: 30px" placeholder="请输入19位卡号" maxlength=19
                      v-model="domain.value"></el-input>
            <el-input style="width: 267px" placeholder="请输入有效卡数量" v-model="domain.value2"
                      maxlength=7></el-input>
            <img src="../../../assets/images/icon_add.png" style="margin-left: 20px" @click.prevent="addDomain()"
                 width="32" height="32" alt="">
            <img src="../../../assets/images/icon_delet.png" v-if="form.domains.length>1" style="margin-left: 8px"
                 @click.prevent="removeDomain(domain)" width="32" height="32" alt="">
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <div class="btn_Sub" @click="subTask('form')">提 交</div>
        <div class="btn_Clo" @click="dialogFormVisible = false">取 消</div>
      </div>
    </el-dialog>
    <!--  开发记录   -->
    <devLog @closeTask="closeProAll" :currRow="currRow" v-if="devLogIs" :isShowManage="true"></devLog>
    <!--  加油站Top5   -->
    <seeTopFive @closeTask="closeProAll" :currRow="currRow" v-if="seeTopFiveIs"></seeTopFive>
    <!--  数据源配置   -->
    <dataSourceConfig
      @closeTask="closeDataSourceConfig"
      :areaListPr="areaListPr"
      :propsData="propsData"
      v-if="dataSourceConfigIs"
    ></dataSourceConfig>
  </div>
</template>

<script>
import {hideExport} from '@/utils/tools'
import http from '@/api/freight' // 请求汇总
import _ from 'lodash'
import WeekDialog from "@/views/freight/weekByCarNum/components/weekDialog.vue";
import Util from "utils/util";
import detailCard from "components/detailCard.vue";
import devLog from "components/devLog.vue";
import seeTopFive from "components/seeTopFive.vue";
import dataSourceConfig from "components/dataSourceConfig.vue";

// 停靠非石化加油站企业列表
export default {
  name: 'car-unpetrified-com',
  components: {seeTopFive, devLog, detailCard, WeekDialog, dataSourceConfig},
  data() {
    return {
      devLogIs: false,
      seeTopFiveIs: false,
      dataSourceConfigIs: false,
      gridData: Util.gridData,
      tableHeight1: this.tableHeight + 50,
      value1: false,
      rules: {
        companyNameMask: [
          {
            required: true,
            message: "请输入客户名称",
            trigger: "blur",
          },
        ],
        companyCreditCodeMask: [
          {
            required: true, validator: this.companyCred, trigger: 'blur'
          },
        ],
        pr: [
          {
            required: true,
            message: "请选择所属省份",
            trigger: "blur",
          },
        ],
        ci: [
          {
            required: true,
            message: "请选择所属城市",
            trigger: "blur",
          },
        ],
        cu: [
          {
            required: true,
            message: "请选择所属区县",
            trigger: "blur",
          },
        ],
        commonCardStatus: [{required: true, message: "请选择是否已有普通卡", trigger: "change"}],
      },
      optionsCommonCardStatus: [
        {
          value: '1',
          label: '是'
        }, {
          value: '0',
          label: '否'
        }
      ],
      isShowMes: false,
      reachStatusOptions: Util.reachStatusOptions,
      companyCardStatusOption: Util.companyCardStatusOption,
      devStatusOption: Util.devStatusOption,
      cardTypeOption: Util.cardTypeOption,
      vehicleCountMaskOption: Util.vehicleCountMaskOption,
      mileageMaskOption: Util.mileageMaskOption,
      devLogOption: Util.devLogOption,
      formData: {
        pr: '',
        ci: '',
        cu: '',
        devLog: '',
        companyCardStatus: ['1','6'],
        cmpnanyDevUser: '',
        companyName: '',
        provCityCounty: '',
        provCode: '',
        cityCode: '',
        countyCode: '',
        time: '',
        cardType: '',
        vehicleCountMask: '',
        mileageMask: '',
        reachStatus: '',
        percentage: '',
        devStatus: '3',
        range: ''
      },
      proptions: [],
      cioptions: [],
      cuoptions: [],
      hideExport,
      dialogFormVisible: false,
      form: {
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        commonCardStatus: '',
        domains: [{
          value: '',
          value2: ''
        }],
      },
      formLabelWidth: '120px',
      conditon: {
        time: '',
        pvovince: '',
        city: '',
        range: '',
        provCode: '',
      },
      userFlagList: [
        {label: '未办卡', value: '0-0'},
        {label: '在用联名卡', value: '0-30'},
        {label: '联名卡流失', value: '30-50'},
        {label: '在用蓝卡', value: '50-80'},
        {label: '蓝卡流失', value: '80-100'},
      ],
      exploitFlagList: [
        {label: '未开发', value: '0-0'},
        {label: '开发中', value: '0-30'},
        {label: '已开发', value: '30-50'},
      ],
      reachFlagList: [
        {label: '未触达', value: '0-0'},
        {label: '已触达', value: '0-30'},
      ],
      rangeList: [
        {label: '0%', value: '0-0'},
        {label: '0-30%', value: '0-30'},
        {label: '30-50%', value: '30-50'},
        {label: '50-80%', value: '50-80'},
        {label: '80%以上', value: '80-100'},
      ],
      provinceList: [],
      tableData: [], // 表格数据
      currentPage: 1,
      total: 0,
      pageSize: 50,

      onDebounceSearch: _.debounce(this.onSearch, 500),
      currRow: '',
      isShowInput: false,
      cardNum: '',
      isChangeci: false,
      isChangecu: false,
      nrData: {},
      areaListPr: []
    }
  },
  mounted() {
    this.getPrInter()
    this.initDate(1)
  },
  methods: {
    closeProAll(curr) {
      this[curr] = false
    },
    showDataSourceDialog() {
      this.dataSourceConfigIs = true
    },
    closeDataSourceConfig(needRefresh) {
      this.dataSourceConfigIs = false
      if (needRefresh) {
        // 如果需要刷新数据，可以在这里调用
        // this.onSearch(null)
      }
    },
    seeDevLog(row) {
      this.devLogIs = true
      this.currRow = row
    },
    seeTopFive(row) {
      this.seeTopFiveIs = true
      this.currRow = row
    },
    async getPrInter() {
      const {data} = await http.getCountyAreaList({code: '0', type: '1', areaType: 'PROVINCE'})
      this.areaListPr = data
          .map(item => ({
            value: item.code,
            label: item.name,
            leaf: false
          }));
      if (this.areaListPr.length == 1) {
        this.cardNum = Util.keyValueCardNum[this.areaListPr[0].value.substring(0, 2)]
      }
    },
    getCiInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'CITY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: code == '110000' || code == '120000' || code == '500000' || code == '310000' || code == '900000' ? true : false
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    getCuInter(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, type: '1', areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        nodes.push({
          value: '-1',
          label: '其他',
          leaf: true
        })
        resolve(nodes);
      })
    },
    changeSearch() {
      if (this.value1) {
        this.tableHeight1 = this.tableHeight - 70
      } else {
        this.tableHeight1 = this.tableHeight + 50
      }
    },
    getPrev() {
      http.getCountyAreaList({
        code: '0',
        areaType: 'PROVINCE'
      }).then((e) => {
        if (e.data.length > 0) {
          this.proptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
        }
      })
    },
    async ciChange() {
      this.cuoptions = []
      this.form.cu = ''
      const {data} = await http.getCountyAreaList({
        code: this.form.ci,
        areaType: 'COUNTY'
      })
      if (data.length > 0) {
        this.cuoptions = data
            .map(item => ({
              value: item.code,
              label: item.name,
            }));
      } else {
        this.cuoptions = this.cioptions.filter(item => item.value == this.form.ci)
      }
      this.form.cu = this.currRow.countycode
    },
    prChange() {
      this.cuoptions = []
      this.cioptions = []
      this.form.ci = ''
      this.form.cu = ''
      http.getCountyAreaList({
        code: this.form.pr,
        areaType: 'CITY'
      }).then((e) => {
        if (e.data.length > 0) {
          this.cioptions = e.data
              .map(item => ({
                value: item.code,
                label: item.name,
              }));
          this.form.ci = this.currRow.citycode
          this.ciChange()
        }
      })
    },
    subTask(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {

          let cityName = '';
          let countyName = '';
          if (this.form.ci) {
            this.cioptions.forEach(item => {
              if (item.value == this.form.ci) {
                cityName = item.label;
              }
            })
          }

          if (this.form.cu) {
            this.cuoptions.forEach(item => {
              if (item.value == this.form.cu) {
                countyName = item.label;
              }
            })
          }

          let params = {
            citycode: this.form.ci,
            cityname: cityName,
            countycode: this.form.cu,
            countyname: countyName,
            commonCardStatus: this.form.commonCardStatus,
            id: this.currRow.id,
            companyCreditCode: this.isShowInput ? this.currRow.companyCreditCode : this.form.companyCreditCodeMask
          }
          if (this.form.commonCardStatus == 1) {
            let commonCardNos = []
            this.form.domains.forEach(item => {
              commonCardNos.push(item.value + '_' + item.value2)
            })
            params.commonCardNos = commonCardNos
          }
          http
              .receiveTask(params)
              .then((e) => {
                if (e.code == 200) {
                  this.$message({
                    message: '任务领取成功，可到目标客户列表进行操作！',
                    type: 'success',
                  })
                  this.onSearch(this.currentPage)
                  this.dialogFormVisible = false
                }
              })
        }
      })
    },
    ruleMobile(rule, value, callback) {
      if (!value.value || !value.value2) {
        callback(new Error('请输入主卡卡号及有效卡数量!'))
      } else {
        if (!/^\d+$/.test(value.value) || !/^\d+$/.test(value.value2)) {
          callback(new Error('请输入数字!'))
        } else {
          if (value.value.length == 19) {
            callback();
          } else {
            callback(new Error('请输入主卡卡号19位数字!'))
          }
        }
      }
    },
    companyCred(rule, value, callback) {
      if (value) {
        if (!this.isShowInput) {
          if (!/^[A-Za-z0-9]+$/.test(value)) {
            callback(new Error('请输入正确的统一社会信用代码！'))
          } else {
            if (value.length != 18) {
              callback(new Error('请输入正确的统一社会信用代码！'))
            } else {
              callback();
            }
          }
        } else {
          callback();
        }
      } else {
        callback(new Error('请输入正确的统一社会信用代码！'))
      }

    },
    showVal(oldVal, newVal) {
      this.form[oldVal] = this.currRow[newVal]
      this.copyEvent(this.form[oldVal])
    },
    copyEvent(text) {
      let ipt = document.createElement('input');
      ipt.value = text;
      document.body.appendChild(ipt);
      ipt.select();
      document.execCommand('Copy');
      ipt.remove();
    },
    async getTask(row) {
      this.form = {
        companyNameMask: '',
        companyCreditCodeMask: '',
        pr: '',
        ci: '',
        cu: '',
        commonCardStatus: '',
        domains: [{
          value: this.cardNum != '' ? this.cardNum : '',
          value2: ''
        }],
      }
      this.currRow = row
      this.dialogFormVisible = true
      await this.getPrev()
      console.log(row)
      this.isShowInput = row.companyCreditCodeMask && row.companyCreditCodeMask != '-' ? true : false
      this.form.companyNameMask = row.companyNameMask
      this.form.companyCreditCodeMask = row.companyCreditCodeMask != '-' ? row.companyCreditCodeMask : ''
      console.log(this.proptions)
      this.form.pr = this.currRow.provcode
      this.isChangeci = this.currRow.citycode && this.currRow.citycode != '' ? true : false
      this.isChangecu = this.currRow.countycode && this.currRow.countycode != '' ? true : false
      this.prChange()
    },
    propsData() {
      const vm = this
      return {
        lazy: true,
        checkStrictly: true,
        expandTrigger: 'hover',
        async lazyLoad(node, resolve) {
          const {level, value} = node;
          if (level === 1) {
            resolve(await vm.getCiInter(value, level));
          } else if (level === 2) {
            resolve(await vm.getCuInter(value, level));
          } else {
            resolve([])
          }
        }
      }
    },
    getListP(code, level) {
      return new Promise(async resolve => {
        const {data} = await http.getCountyAreaList({code, areaType: 'COUNTY'})
        const nodes = data
            .map(item => ({
              value: item.code,
              label: item.name,
              leaf: true
            }));
        resolve(nodes);
      })
    },
    removeDomain(item) {
      var index = this.form.domains.indexOf(item)
      if (index !== -1) {
        this.form.domains.splice(index, 1)
      }
    },
    addDomain() {
      this.form.domains.push({
        value: this.cardNum != '' ? this.cardNum : '',
        value2: '',
        key: Date.now()
      });
    },
    toDetail(row) {
      this.nrData = row
      this.isShowMes = true
    },
    changeDetail() {
      this.isShowMes = false
    },
    getProvinceList() {
      http.carUnpetrifiedComProv().then((e) => {
        if (e.code == 200 && e.data) {
          this.provinceList = e.data
        }
      })
    },
    initDate(num = 2) {
      if (num == 2 && this.formData.time == '') {
        this.$message({
          message: '请选择月份',
          type: 'warning',
        })
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const params = {
        time: this.formData.time,
        page: this.currentPage,
        pageSize: this.pageSize,
        isRecord: this.formData.devLog,
        provCode: this.formData.provCityCounty[0] || '',
        cityCode: this.formData.provCityCounty[1] || '',
        countyCode: this.formData.provCityCounty[2] || '',
        companyName: this.formData.companyName,
        devUser: this.formData.cmpnanyDevUser,
        reachStatus: this.formData.reachStatus,
        cardType: this.formData.cardType,
        vehicleCountMask: this.formData.vehicleCountMask,
        mileageMask: this.formData.mileageMask,
        percentage: this.formData.percentage,
        devStatus: this.formData.devStatus,
        companyCardStatus: this.formData.companyCardStatus.length > 0 ? this.formData.companyCardStatus.join(',') : ''
      }
      // 初始化数据

      http
          .customersAll(params)
          .then((e) => {
            loading.close();
            if (e.code == 200 && e.data.pageInfo && e.data.pageInfo.dataList) {
              if (e.data.time) {
                this.formData.time = e.data.time
              }
              e.data.pageInfo.dataList.forEach(item => {
                Object.keys(item).forEach(item2 => {
                  if (item2 != 'citycode' && item2 != 'countycode') {
                    item[item2] = item[item2] || item[item2] === 0 ? item[item2] : '-'
                  }
                })
              })
              let curTime = e.data.curTime;

              this.tableData = e.data.pageInfo.dataList.map((_) => {
                _.decryptedCompanyName = false
                _.companyCreditCodeIs = false
                _.cmpnanyDevStartTime = _.devStartTime != '-' ? Util.format(new Date(_.devStartTime * 1).getTime(), "yyyy-MM-dd") : '-'
                _.cmpnanyDevEndTime = _.devEndTime != '-' ? Util.format(new Date(_.devEndTime * 1).getTime(), "yyyy-MM-dd") : '-'
                _.companyCardStatusText = this.getNmae(Util.companyCardStatusOption, _.companyCardStatus)
                _.companyDevStatusText = this.getNmae(Util.devStatusOption, _.devStatus.toString())
                _.cardTypeText = this.getNmae(Util.cardTypeOption, _.cardType)
                _.reachStatusText = this.getNmae(Util.reachStatusOptions, _.reachStatus)
                _.failedTypeText="-";
                if(_.failedKind){
                  _.failedTypeText = this.getNmae(Util.failedKindOption, _.failedKind) + " / "
                }
                if(_.failedType){
                  _.failedTypeText = _.failedTypeText + this.getNmae(Util.failedTypeOption, _.failedType)
                }
                _.isHistory = (_.year + "" + _.month) != curTime
                return _
              })
              this.total = e.data.pageInfo.total
              this.currentPage = e.data.pageInfo.pageNum

            } else {
              this.tableData = []
            }
          })
    },
    handleCurrentChange(index) {
      this.currentPage = index
      this.initDate(2)
    },
    handleSizeChange(val) {
      this.currentPage = 1
      this.pageSize = val
      this.initDate(2)
    },
    getNmae(allData, val) {
      let curr = allData.filter(item => {
        return item.value == val
      })
      if (curr.length > 0) {
        return curr[0].label
      } else {
        return '-'
      }
    },
    format(num) {
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
    onSearch(val) {
      console.log('test')
      this.currentPage = val ? val : 1
      this.total = 0
      this.initDate(2)
    },
    onPrev() {
      // 返回上级
      this.$router.push({
        name: 'carStopBrand',
      })
    },
  },
}
</script>

<style lang="stylus" scoped>
.proTextSty {
  font-size: 14px;
}

.tableTitleSty {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  margin-top: 10px;
}

.searchBtn {
  background: #41B883;
  color: #ffffff;
}

.cardMesSty {
  display: flex;
  align-items: center;
}

.car-unpetrified-com {
  padding: 20px;
  background: #fff;
  border-radius: 10px;

  main {
    flex: 1;
  }

  .block {
    display: flex;

    .center {
      margin: 10px auto;
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
}

.formSty {
  /deep/ .el-form-item__label {
    line-height: 20px;
  }

  /deep/ .el-input--medium .el-input__inner {
    height: 32px;
    line-height: 32px;
  }
}

/deep/ .el-form--inline .el-form-item {
  margin-right: 32px;
}

/deep/ .el-table__empty-block {
  width: 100% !important;
}

/deep/ .el-dialog__body {
  padding: 20px 0 20px 30px;
  border-bottom: 2px solid #EEEEEE;
}

/deep/ .el-dialog__header {
  padding: 0;
  background: rgba(52, 109, 176, 0.06);
  border-radius: 2px 2px 0px 0px;

  .el-dialog__title {
    display: block;
    line-height: 56px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.85);
    text-align: left;
    font-style: normal;
    padding-left: 30px;
  }
}

.btn_Sub {
  width: 64px;
  line-height: 33px;
  background: #336EB0;
  border-radius: 2px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
  font-style: normal;
  padding: 0;
}

.btn_Clo {
  width: 64px;
  line-height: 33px;
  border-radius: 2px;
  border: 1px solid #D9D9D9;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
  font-style: normal;
  padding: 0;
  margin-left: 8px;
}
</style>
